import { SVGProps } from '@components/Icon/types';

export const AssessmentStages = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1, 6)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 7.86173C21.1043 7.86173 21.9996 8.78845 22 9.93086C22 11.0736 21.1046 12 20 12C19.1043 12 18.3465 11.391 18.0918 10.5512H12.9082C12.6535 11.391 11.8957 12 11 12C10.1043 12 9.34647 11.391 9.0918 10.5512H3.9082C3.65352 11.391 2.89574 12 2 12C0.89543 12 0 11.0736 0 9.93086C0.000390317 8.78845 0.895671 7.86173 2 7.86173C2.89539 7.86173 3.65324 8.47125 3.9082 9.31053H9.0918C9.34677 8.47127 10.1046 7.86173 11 7.86173C11.8954 7.86173 12.6532 8.47127 12.9082 9.31053H18.0918C18.3468 8.47125 19.1046 7.86173 20 7.86173ZM2 8.8963C1.44796 8.8963 1.00039 9.35983 1 9.93086C1 10.5022 1.44772 10.9654 2 10.9654C2.55228 10.9654 3 10.5022 3 9.93086C2.99961 9.35983 2.55204 8.8963 2 8.8963ZM11 8.8963C10.448 8.8963 10.0004 9.35984 10 9.93086C10 10.5022 10.4477 10.9654 11 10.9654C11.5523 10.9654 12 10.5022 12 9.93086C11.9996 9.35984 11.552 8.8963 11 8.8963ZM20 8.8963C19.448 8.8963 19.0004 9.35983 19 9.93086C19 10.5022 19.4477 10.9654 20 10.9654C20.5523 10.9654 21 10.5022 21 9.93086C20.9996 9.35983 20.552 8.8963 20 8.8963Z"
        fill={fill}
      />
      <path
        d="M14.5811 0.211581C14.8547 -0.0709327 15.2972 -0.0704571 15.5703 0.212591C15.8431 0.495688 15.8428 0.95361 15.5693 1.23605L11.3174 5.62791C11.0442 5.91004 10.6014 5.90985 10.3281 5.62791L8.20508 3.43147C7.93203 3.14874 7.93209 2.69079 8.20508 2.40802C8.47845 2.1252 8.92195 2.1252 9.19531 2.40802L10.8223 4.09121L14.5811 0.211581Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'assessment-stages';
